{
  "name": "tonightpass",
  "version": "0.0.263",
  "description": "@tonightpass sdk and tools.",
  "repository": {
    "type": "git",
    "url": "https://github.com/tonightpass/tonightpass.git",
    "directory": "packages/node"
  },
  "bugs": "https://github.com/tonightpass/tonightpass/issues",
  "homepage": "https://tonightpass.com",
  "license": "MIT",
  "keywords": [
    "tonightpass",
    "api",
    "sdk",
    "typescript",
    "javascript",
    "rest",
    "client"
  ],
  "files": [
    "dist",
    "README.md"
  ],
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "test": "tsx tests/index.ts"
  },
  "dependencies": {
    "@mikro-orm/core": "^6.2.9",
    "@nestjs/terminus": "^11.0.0",
    "class-transformer": "^0.5.1",
    "class-validator": "^0.14.0",
    "pathcat": "^1.2.2",
    "redaxios": "^0.5.1",
    "reflect-metadata": "^0.2.1",
    "stripe": "^18.0.0"
  },
  "devDependencies": {
    "@types/node": "22.18.6",
    "tsx": "^4.7.1",
    "typescript": "^5.0.0"
  }
}
